import { useEffect } from 'react'
import { useAdmin } from '@/contexts/AdminContext'

export const ScriptInjector = () => {
  const { gtmId, headerScripts, bodyScripts } = useAdmin()

  // Handle GTM Injection
  useEffect(() => {
    // Cleanup old GTM
    const existingScript = document.getElementById('dp6-gtm-script')
    const existingNoscript = document.getElementById('dp6-gtm-noscript')
    if (existingScript) existingScript.remove()
    if (existingNoscript) existingNoscript.remove()

    if (gtmId) {
      // Inject Script
      const script = document.createElement('script')
      script.id = 'dp6-gtm-script'
      // Initialize DataLayer and Consent Mode Default
      script.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied',
        'wait_for_update': 500
      });
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');`
      document.head.prepend(script)

      // Inject Noscript
      const noscript = document.createElement('noscript')
      noscript.id = 'dp6-gtm-noscript'
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`
      document.body.prepend(noscript)
    }
  }, [gtmId])

  // Handle Custom Header Scripts
  useEffect(() => {
    // Cleanup
    document
      .querySelectorAll('[data-dp6-header-script]')
      .forEach((el) => el.remove())

    if (!headerScripts.trim()) return

    try {
      const range = document.createRange()
      range.selectNode(document.head)
      const fragment = range.createContextualFragment(headerScripts)

      Array.from(fragment.children).forEach((child) => {
        child.setAttribute('data-dp6-header-script', 'true')
        document.head.appendChild(child)
      })
    } catch (e) {
      console.error('Failed to inject header scripts', e)
    }
  }, [headerScripts])

  // Handle Custom Body Scripts
  useEffect(() => {
    // Cleanup
    const existingContainer = document.getElementById('dp6-custom-body')
    if (existingContainer) existingContainer.remove()

    if (!bodyScripts.trim()) return

    try {
      const container = document.createElement('div')
      container.id = 'dp6-custom-body'

      const range = document.createRange()
      range.selectNode(document.body)
      const fragment = range.createContextualFragment(bodyScripts)

      container.appendChild(fragment)
      document.body.prepend(container)
    } catch (e) {
      console.error('Failed to inject body scripts', e)
    }
  }, [bodyScripts])

  return null
}
